import Vue from 'vue';
import ElementUI from 'element-ui';
import * as VueGoogleMaps from 'vue2-google-maps';
import lang from 'element-ui/lib/locale/lang/es';
import locale from 'element-ui/lib/locale';
import App from './App.vue';
import router from './router';
import axios from './backend/vue-axios';
import { initializeDatadogRum } from './observability/datadogRum';
import GoogleMapsLoader from './app/components/maps/config';
import './assets/scss/element-variables.scss';

locale.use(lang);

const googleMapsLoadOptions = {
  version: GoogleMapsLoader.VERSION,
  language: GoogleMapsLoader.LANGUAGE,
  libraries: GoogleMapsLoader.LIBRARIES,
  channel: GoogleMapsLoader.CHANNEL,
};

if (GoogleMapsLoader.KEY) {
  googleMapsLoadOptions.key = GoogleMapsLoader.KEY;
} else if (GoogleMapsLoader.CLIENT) {
  googleMapsLoadOptions.client = GoogleMapsLoader.CLIENT;
}

Vue.use(ElementUI);
Vue.use(VueGoogleMaps, {
  load: googleMapsLoadOptions,
});

Vue.config.productionTip = false;

initializeDatadogRum(router);

new Vue({
  router,
  axios,
  render: h => h(App),
}).$mount('#app');
